export default String.raw`
<rect width="360" height="1322" class="bgColor"/>
<g id="Sekcje rozwijalne/Podobne produkty">
    <g id="Frame 677">
        <g id="Nag&#197;&#130;&#195;&#179;wek">
            <text id="Koszyk 1" class="primaryColorFont"   font-family="Inter" font-size="24" font-weight="500" letter-spacing="0px">
                <tspan x="16.4023" y="52.7273">TRANSLATION_Prv_Cart_Title</tspan>
            </text>
            <g id="Frame 777">
                <g id="Share">
                    <rect x="249" y="25" width="38" height="38" rx="4" class="btnSolidBgColor--stroke" stroke-width="2"/>
                    <rect x="249" y="25" width="38" height="38" rx="4" fill="#FFFFFF"/>
                    <g id="Interface/Invoice" transform="translate(258.000000, 34.000000)">
                        <use class="btnSolidBgColor" xlink:href="#file-invoice-dollar" width="20" height="20"></use>
                    </g>
                </g>
                <g id="Mail">
                    <rect x="305" y="25" width="38" height="38" rx="4" class="btnSolidBgColor--stroke" stroke-width="2"/>
                    <rect x="305" y="25" width="38" height="38" rx="4" fill="#FFFFFF"/>
                    <g id="Navigation/Delete" transform="translate(314.000000, 34.000000)">
                        <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                    </g>
                </g>
            </g>
        </g>
        <g id="Tabela">
            <g id="Kafelek produktu/koszyk/mobile">
                <g id="Kafelek produktu">
                    <g id="Frame 179">
                        <image x="26" y="98" width="60" height="60" href="./img/previewElements/cartItem1.png" />
                    </g>
                    <g id="Frame 923">
                        <g id="Frame 922">
                            <text id="Gong dwutonowy FORTE 230V bia&#197;&#130;y GNS-223-BIAG" class="primaryColor"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                <tspan x="112" y="103.091">QuantumCore Ultra </tspan>
                                <tspan x="112" y="123.091">X9 Pro</tspan>
                            </text>
                            <g id="delete">
                                <g id="Navigation/Delete_2" transform="translate(315.000000, 98.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <g id="Frame 705">
                            <foreignObject x="112" y="140" width="220" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                    <span>TRANSLATION_Prv_Cart_Spec_EightCores</span>
                                    <span style="color: #E8E8E8;">|</span>
                                    <span>TRANSLATION_Prv_Cart_Spec_SixteenThreads</span>
                                </div>
                            </foreignObject>
                            <g id="Punkty">
                                <g id="Interface/Award" transform="translate(112.000000, 160.000000)">
                                    <use fill="#2E2E2E" xlink:href="#award" width="22" height="22"></use>
                                </g>
                                <text id="+ 5 pkt" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                    <tspan x="140" y="176.364">+ 5 pkt</tspan>
                                </text>
                            </g>
                            <path id="Rectangle 188" d="M189 164H190V180H189V164Z" fill="#E8E8E8"/>
                            <g id="Status">
                                <text id="Status label" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                    <tspan x="200" y="176.364">TRANSLATION_Prv_ProductsList_Available</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
                <g id="Frame 911">
                    <g id="Cena netto brutto">
                        <g id="Cena podstawowa">
                            <foreignObject x="16" y="202" width="160" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: baseline; gap: 4px; font-family: Inter; font-size: 14px; letter-spacing: 0px;">
                                    <span style="font-weight: 600;">3 299,89 zł</span>
                                    <span style="font-size: 12px;">TRANSLATION_Prv_ProductsList_Netto</span>
                                </div>
                            </foreignObject>
                        </g>
                        <text id="390 000,67 z&#197;&#130; brutto" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                            <tspan x="16" y="236.364">4 058,86 z&#x142; brutto </tspan>
                        </text>
                    </g>
                    <g id="Frame 909">
                        <g id="VAT">
                            <text id="VAT:" class="primaryColorFont"   font-family="Inter" font-size="12" font-weight="600" letter-spacing="0px">
                                <tspan x="188" y="212.364">VAT:</tspan>
                            </text>
                            <text id="23%" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                <tspan x="219" y="212.364">23%</tspan>
                            </text>
                        </g>
                    </g>
                </g>
                <g id="Frame 562">
                    <g id="Frame 910">
                        <g id="Frame 900">
                            <g id="Frame 585">
                                <g id="Amount WCAG">
                                    <rect x="16.5" y="256.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                    <rect x="16.5" y="256.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                    <g id="Icon" transform="translate(26.000000, 268.000000)">
                                        <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                    </g>
                                    <g>
                                    <text id="9999" class="primaryColorFont" text-anchor="middle" transform="translate(-62.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan x="124.6328" y="281.091">9</tspan>
                                    </text>
                                    </g>
                                    <g id="Icon_2" transform="translate(86.000000, 268.000000)">
                                        <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>
                                    </g>
                                </g>
                                <foreignObject x="110" y="268" width="40" height="24">
                                    <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 12px;">TRANSLATION_Prv_Cart_Pcs</div>
                                </foreignObject>
                            </g>
                        </g>
                    </g>
                    <g id="Frame 913">
                        <g id="Frame 908">
                            <foreignObject x="188" y="258" width="152" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: baseline; gap: 4px; font-family: Inter; font-size: 14px; font-weight: 500; letter-spacing: 0px;">
                                    <span>29 699,01 zł</span>
                                    <span style="font-size: 12px; font-weight: 400;">TRANSLATION_Prv_ProductsList_Netto</span>
                                </div>
                            </foreignObject>
                        </g>
                        <text id="1390 000,67 z&#197;&#130; brutto" class="primaryColorFont"   font-family="Inter" font-size="10" font-weight="500" letter-spacing="0px">
                            <tspan x="188" y="291.136">36 529,74 z&#x142; brutto</tspan>
                        </text>
                    </g>
                </g>
                <line id="Divider" x1="16" y1="311.5" x2="344" y2="311.5" stroke="#E7E7E7"/>
            </g>
            <g id="Kafelek produktu/koszyk/mobile_2">
                <g id="Kafelek produktu_2">
                    <g id="Frame 179_2">
                        <image x="26" y="338" width="60" height="60" href="./img/previewElements/cartItem2.png" />
                    </g>
                    <g id="Frame 923_2">
                        <g id="Frame 922_2">
                            <text id="Gong dwutonowy FORTE 230V bia&#197;&#130;y GNS-223-BIAG_2" class="primaryColor"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                <tspan x="112" y="343.091">HyperThread Advanced </tspan>
                                <tspan x="112" y="363.091">A12 Extreme</tspan>
                            </text>
                            <g id="delete_2">
                                <g id="Navigation/Delete_3" transform="translate(315.000000, 338.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <g id="Frame 705_2">
                            <foreignObject x="112" y="380" width="220" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                    <span>TRANSLATION_Prv_Cart_Spec_EightCores</span>
                                    <span style="color: #E8E8E8;">|</span>
                                    <span>TRANSLATION_Prv_Cart_Spec_TwentyFourThreads</span>
                                </div>
                            </foreignObject>
                            <g id="Punkty_2">
                                <g id="Interface/Award_2" transform="translate(112.000000, 400.000000)">
                                    <use fill="#2E2E2E" xlink:href="#award" width="22" height="22"></use>
                                </g>
                                <text id="+ 5 pkt_2" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                    <tspan x="140" y="416.364">+ 5 pkt</tspan>
                                </text>
                            </g>
                            <path id="Rectangle 188_2" d="M189 404H190V420H189V404Z" fill="#E8E8E8"/>
                            <g id="Status_2">
                                <text id="Status label_2" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                    <tspan x="200" y="416.364">TRANSLATION_Prv_ProductsList_Available</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
                <g id="Frame 911_2">
                    <g id="Cena netto brutto_2">
                        <g id="Cena podstawowa_2">
                            <foreignObject x="16" y="442" width="160" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: baseline; gap: 4px; font-family: Inter; font-size: 14px; letter-spacing: 0px;">
                                    <span style="font-weight: 600;">3 999,99 zł</span>
                                    <span style="font-size: 12px;">TRANSLATION_Prv_ProductsList_Netto</span>
                                </div>
                            </foreignObject>
                        </g>
                        <text id="390 000,67 z&#197;&#130; brutto_2" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                            <tspan x="16" y="476.364">4 919,99 z&#x142; brutto </tspan>
                        </text>
                    </g>
                    <g id="Frame 909_2">
                        <g id="VAT_2">
                            <text id="VAT:_2" class="primaryColorFont"   font-family="Inter" font-size="12" font-weight="600" letter-spacing="0px">
                                <tspan x="188" y="452.364">VAT:</tspan>
                            </text>
                            <text id="23%_2" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                <tspan x="219" y="452.364">23%</tspan>
                            </text>
                        </g>
                    </g>
                </g>
                <g id="Frame 562_2">
                    <g id="Frame 910_2">
                        <g id="Frame 900_2">
                            <g id="Frame 585_2">
                                <g id="Amount WCAG_2">
                                    <rect x="16.5" y="496.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                    <rect x="16.5" y="496.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                    <g id="Icon_3" transform="translate(26.000000, 508.000000)">
                                        <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                    </g>
                                    <text id="9999_2" class="primaryColorFont" text-anchor="middle" transform="translate(-62.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan x="124.6328" y="521.091">7</tspan>
                                    </text>
                                    <g id="Icon_4" transform="translate(86.000000, 508.000000)">
                                        <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>
                                    </g>
                                </g>
                                <foreignObject x="110" y="508" width="40" height="24">
                                    <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 12px;">TRANSLATION_Prv_Cart_Pcs</div>
                                </foreignObject>
                            </g>
                        </g>
                    </g>
                    <g id="Frame 913_2">
                        <g id="Frame 908_2">
                            <foreignObject x="188" y="498" width="152" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: baseline; gap: 4px; font-family: Inter; font-size: 14px; font-weight: 500; letter-spacing: 0px;">
                                    <span>27 999,93 zł</span>
                                    <span style="font-size: 12px; font-weight: 400;">TRANSLATION_Prv_ProductsList_Netto</span>
                                </div>
                            </foreignObject>
                        </g>
                        <text id="1390 000,67 z&#197;&#130; brutto_2" fill="#767676"   font-family="Inter" font-size="10" font-weight="500" letter-spacing="0px">
                            <tspan x="188" y="531.136">34 439,93 z&#x142; brutto</tspan>
                        </text>
                    </g>
                </g>
                <line id="Divider_2" x1="16" y1="551.5" x2="344" y2="551.5" stroke="#E7E7E7"/>
            </g>
            <g id="Kafelek produktu/koszyk/mobile_3">
                <g id="Kafelek produktu_3">
                    <g id="Frame 179_3">
                        <image x="26" y="578" width="60" height="60" href="./img/previewElements/cartItem3.png" />
                    </g>
                    <g id="Frame 923_3">
                        <g id="Frame 922_3">
                            <text id="Gong dwutonowy FORTE 230V bia&#197;&#130;y GNS-223-BIAG_3" class="primaryColor"   font-family="Inter" font-size="14" font-weight="500" letter-spacing="0px">
                                <tspan x="112" y="583.091">QuantumCore FORTE 230V </tspan>
                                <tspan x="112" y="603.091">biały GNS-223-BIAGNS-223</tspan>
                            </text>
                            <g id="delete_3">
                                <g id="Navigation/Delete_4" transform="translate(315.000000, 578.000000)">
                                    <use class="btnSolidBgColor" xlink:href="#trash-alt" width="20" height="20"></use>
                                </g>
                            </g>
                        </g>
                        <g id="Frame 705_3">
                            <foreignObject x="112" y="620" width="220" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 8px; font-family: Inter; font-size: 12px; white-space: nowrap;">
                                    <span>TRANSLATION_Prv_Cart_Spec_TwentyCores</span>
                                    <span style="color: #E8E8E8;">|</span>
                                    <span>TRANSLATION_Prv_Cart_Spec_TwentyFourThreads</span>
                                </div>
                            </foreignObject>
                            <g id="Punkty_3">
                                <g id="Interface/Award_3" transform="translate(112.000000, 640.000000)">
                                    <use fill="#2E2E2E" xlink:href="#award" width="22" height="22"></use>
                                </g>
                                <text id="+ 5 pkt_3" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                    <tspan x="140" y="656.364">+ 5 pkt</tspan>
                                </text>
                            </g>
                            <path id="Rectangle 188_3" d="M189 644H190V660H189V644Z" fill="#E8E8E8"/>
                            <g id="Status_3">
                                <text id="Status label_3" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                    <tspan x="200" y="656.364">TRANSLATION_Prv_ProductsList_Available</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
                <g id="Frame 911_3">
                    <g id="Cena netto brutto_3">
                        <g id="Cena podstawowa_3">
                            <foreignObject x="16" y="682" width="160" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: baseline; gap: 4px; font-family: Inter; font-size: 14px; letter-spacing: 0px;">
                                    <span style="font-weight: 600;">3 799,00 zł</span>
                                    <span style="font-size: 12px;">TRANSLATION_Prv_ProductsList_Netto</span>
                                </div>
                            </foreignObject>
                        </g>
                        <text id="390 000,67 z&#197;&#130; brutto_3" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                            <tspan x="16" y="716.364">4 672,77 z&#x142; brutto </tspan>
                        </text>
                    </g>
                    <g id="Frame 909_3">
                        <g id="VAT_3">
                            <text id="VAT:_3" class="primaryColorFont"   font-family="Inter" font-size="12" font-weight="600" letter-spacing="0px">
                                <tspan x="188" y="692.364">VAT:</tspan>
                            </text>
                            <text id="23%_3" class="primaryColorFont"   font-family="Inter" font-size="12" letter-spacing="0px">
                                <tspan x="219" y="692.364">23%</tspan>
                            </text>
                        </g>
                    </g>
                </g>
                <g id="Frame 562_3">
                    <g id="Frame 910_3">
                        <g id="Frame 900_3">
                            <g id="Frame 585_3">
                                <g id="Amount WCAG_3">
                                    <rect x="16.5" y="736.5" width="90" height="39" rx="4.5" stroke="#767676"/>
                                    <rect x="16.5" y="736.5" width="90" height="39" rx="4.5" class="inputsBgColor"/>
                                    <g id="Icon_5" transform="translate(26.000000, 748.000000)">
                                        <use fill="#959595" xlink:href="#minus" width="11" height="16"></use>
                                    </g>
                                    <text id="9999_3" class="primaryColorFont" text-anchor="middle"  transform="translate(-62.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                        <tspan x="124.6328" y="761.091">6</tspan>
                                    </text>
                                    <g id="Icon_6" transform="translate(86.000000, 748.000000)">
                                        <use fill="#959595" xlink:href="#plus" width="11" height="16"></use>
                                    </g>
                                </g>
                                <foreignObject x="110" y="748" width="40" height="24">
                                    <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="font-family: Inter; font-size: 12px;">TRANSLATION_Prv_Cart_Pcs</div>
                                </foreignObject>
                            </g>
                        </g>
                    </g>
                    <g id="Frame 913_3">
                        <g id="Frame 908_3">
                            <foreignObject x="188" y="738" width="152" height="20">
                                <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: baseline; gap: 4px; font-family: Inter; font-size: 14px; font-weight: 500; letter-spacing: 0px;">
                                    <span>22 794,00 zł</span>
                                    <span style="font-size: 12px; font-weight: 400;">TRANSLATION_Prv_ProductsList_Netto</span>
                                </div>
                            </foreignObject>
                        </g>
                        <text id="1390 000,67 z&#197;&#130; brutto_3" class="primaryColorFont"   font-family="Inter" font-size="10" font-weight="500" letter-spacing="0px">
                            <tspan x="188" y="771.136">28 036,62 z&#x142; brutto</tspan>
                        </text>
                    </g>
                </g>
            </g>
            <g id="Pagination">
                <g id="4. Text Button">
                    <g id="Arrows/chevron left" transform="translate(110.217000, 804.500000)">
                        <use class="primaryColor" xlink:href="#chevron-left" width="16" height="16"></use>
                    </g>
                </g>
                <g id="Pages">
                    <g id="Page 3">
                        <text id="Number_3" fill="#2E2E2E"   font-family="Inter" font-size="14" font-weight="600" letter-spacing="0px">
                            <tspan x="142.255" y="817.091">1</tspan>
                        </text>
                    </g>
                    <g id="Page 4">
                        <text id="Number_4" fill="#767676"   font-family="Inter" font-size="14" letter-spacing="0px">
                            <tspan x="174.207" y="817.091">2</tspan>
                        </text>
                    </g>
                    <g id="Page 5">
                        <text id="Number_5" fill="#767676"   font-family="Inter" font-size="14" letter-spacing="0px">
                            <tspan x="206.378" y="817.091">3</tspan>
                        </text>
                    </g>
                </g>
                <g id="4. Text Button_2">
                    <g id="Arrows/chevron right" transform="translate(238.217000, 804.500000)">
                        <use class="primaryColor" xlink:href="#chevron-right" width="16" height="16"></use>
                    </g>
                </g>
            </g>
        </g>
        <g id="Podsumowanie">
            <g id="Podsumowanie_2">
                <!--
                <g id="Punkty_4">
                    <rect x="16" y="856" width="328" height="120" rx="8" fill="#F8F9FA"/>
                    <g id="Frame 805">
                        <g id="Interface/Award_4" transform="translate(34.000000, 895.000000)">
                            <use fill="#2E2E2E" xlink:href="#award" width="42" height="42"></use>
                        </g>
                        
                        <g id="Frame 806">
                            <g id="Za to zam&#195;&#179;wienie otrzymasz 862 punkty.">
                                <text class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="96" y="887.091">TRANSLATION_Prv_Cart_MobileLoyaltyFirstText</tspan>
                                    <tspan x="96" y="907.091">TRANSLATION_Prv_Cart_SecondMobileLoyaltyFirstText</tspan>
                                </text>
                            </g>
                            <g id="Towary: +10 pkt">
                                <text class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="96" y="931.091">TRANSLATION_Prv_Cart_LoyaltySecondText</tspan>
                                </text>
                            </g>
                            <g id="Warto&#197;&#155;&#196;&#135; zam&#195;&#179;wienia: +852 pkt">
                                <text class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                    <tspan x="96" y="955.091">TRANSLATION_Prv_Cart_LoyaltyThirdText</tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
                -->
                <g id="Podsumowanie kwota">
                    <g id="Tytu&#197;&#130;">
                        <g id="Frame 891">
                            <text id="Metoda dostawy" class="primaryColorFont"   font-family="Inter" font-size="18" font-weight="600" letter-spacing="0px">
                                <tspan x="16.4404" y="1018.55">TRANSLATION_Prv_Cart_Summary</tspan>
                            </text>
                        </g>
                    </g>
                    <g id="Frame 584">
                        <g id="Frame 567">
                            <text id="Warto&#197;&#155;&#196;&#135; VAT:" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                <tspan x="16" y="1055.09">TRANSLATION_Prv_Cart_VatValue:</tspan>
                            </text>
                            <text id="536,00 z&#197;&#130;" class="primaryColorFont" transform="translate(-100.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                <tspan direction="rtl" x="440" y="1055.09">30 827,40 z&#x142;</tspan>
                            </text>
                        </g>
                        <g id="Frame 565">
                            <text id="Warto&#197;&#155;&#196;&#135; netto:" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                <tspan x="16" y="1083.09">TRANSLATION_Prv_Cart_NettoValuePrice:</tspan>
                            </text>
                            <text id="2 330,44 z&#197;&#130;" class="primaryColorFont"  transform="translate(-100.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                <tspan direction="rtl" x="440" y="1083.09">134 032,21 z&#x142;</tspan>
                            </text>
                        </g>
                        <g id="Frame 566">
                            <text id="Warto&#197;&#155;&#196;&#135; brutto:" class="primaryColorFont"   font-family="Inter" font-size="14" letter-spacing="0px">
                                <tspan x="16" y="1111.09">TRANSLATION_Prv_Cart_ValuePrice:</tspan>
                            </text>
                            <text id="2 866,44 z&#197;&#130;" class="primaryColorFont" transform="translate(-100.000000, 0)"  font-family="Inter" font-size="14" letter-spacing="0px">
                                <tspan direction="rtl" x="440" y="1111.09">164 859,61 z&#x142;</tspan>
                            </text>
                        </g>
                    </g>
                    <g id="Frame 562_4">
                        <text id="Do zap&#197;&#130;aty:" class="primaryColorFont"   font-family="Inter" font-size="18" font-weight="600" letter-spacing="0px">
                            <tspan x="16" y="1178.55">TRANSLATION_Prv_Cart_ToPay:</tspan>
                        </text>
                        <text id="999 999,99 z&#197;&#130;_4" class="primaryColorFont"  transform="translate(-100.000000, 0)"  font-family="Inter" font-size="18" font-weight="600" letter-spacing="0px">
                            <tspan direction="rtl" x="450" y="1178.55">164 859,61 z&#x142;</tspan>
                        </text>
                    </g>
                </g>
            </g>
            <g id="Buttony">
                <g id="Primary button">
                    <rect x="16" y="1208" width="328" height="40" rx="5" class="btnSolidBgColor"/>
                    <foreignObject x="16" y="1208" width="328" height="40">
                        <div xmlns="http://www.w3.org/1999/xhtml" class="btnSolidTextColor" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; font-family: Inter; font-size: 14px; font-weight: 600; letter-spacing: 0px;">
                            <span>TRANSLATION_Prv_Cart_GoToCart</span>
                        </div>
                    </foreignObject>
                </g>
                <g id="4. Text Button_3">
                    <foreignObject x="16" y="1262" width="328" height="30">
                        <div xmlns="http://www.w3.org/1999/xhtml" class="btnSolidBgColor" style="display: flex; justify-content: center; align-items: center; gap: 8px; width: 100%; height: 100%; font-family: Inter; font-size: 14px; font-weight: 600; letter-spacing: 0px;">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor"><use href="#chevron-left"></use></svg>
                            <span>TRANSLATION_Prv_BackToShopping</span>
                        </div>
                    </foreignObject>
                </g>
            </g>
        </g>
    </g>
</g>`;